export default __webpack_public_path__ + "static/media/Change-sim-card_32.78367cca.svg";